import { Pipe, PipeTransform } from '@angular/core';

const agentNameMappings: Record<string, string> = {
  github: 'GitHub Copilot',
  agentKit: 'AgentKit',
  slack: 'Slack',
  m365copilot: 'M365 Copilot',
  azureAiFoundry: 'Azure AI Foundry',
  chatGptEnterprise: 'ChatGPT Enterprise',
  claude: 'Claude',
  copilotStudio: 'Copilot Studio',
  perplexity: 'Perplexity',
  cursor: 'Cursor',
  unknown: 'Unknown',
};

@Pipe({
  name: 'agentNameToLabel',
  standalone: true,
})
export class AgentNameToLabelPipe implements PipeTransform {
  public transform(value?: string): string {
    if (!value) {
      return '';
    }
    return agentNameMappings[value];
  }
}
